<div class="row page-title">
  <app-back-button></app-back-button>
  <span>{{ localizationConstants.TECH_COVER_PAGE_TITLE | translate }}</span>
</div>
<div class="u-mb--xlarge">
  <div class="row">
    <div
      [@slideAnimation]="animationKey"
      class="outlet-container col-12 col-xl-9 u-p--medium">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <div class="col-12 col-xl-3 card-container u-flex-column gap-xl u-p--medium">
      <mat-card
        appearance="outlined"
        class="software-support-card">
        <mat-card-header>
          <mat-card-title>{{
            localizationConstants.TECH_COVER_SOFTWARE_SUPPORT | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul
            *ngIf="techCoverContact()"
            class="contact-list">
            <li>
              <a
                class="contact-detail"
                [href]="'mailto:' + techCoverContact().email"
                target="_blank">
                <mat-icon
                  color="primary"
                  svgIcon="email"></mat-icon>
                <span class="contact-support-ticket">{{ techCoverContact().email }}</span>
              </a>
            </li>
            <li *ngIf="techCoverContact().phone">
              <a
                class="contact-detail"
                [href]="'tel:' + techCoverContact().phone">
                <mat-icon
                  color="primary"
                  svgIcon="phone"></mat-icon>
                <span class="contact-support-ticket">{{ techCoverContact().phone }}</span>
              </a>
            </li>
          </ul>
        </mat-card-content>
      </mat-card>
      <mat-card
        appearance="outlined"
        class="release-software-card">
        <mat-card-header>
          <mat-card-title class="software-release-title">{{
            localizationConstants.TECH_COVER_RECENT_UPDATES | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="software-releases-container">
          <mat-list>
            <ng-container
              *ngFor="
                let release of techCoverTicketsDataService.supportedSoftware();
                let last = last
              ">
              <ng-container *ngFor="let version of release.softwareVersions">
                <mat-list-item lines="2">
                  <span matListItemTitle>{{ release.softwareName }}</span>
                  <span matListItemLine>
                    {{ version.releaseDate | date }}
                    <span class="software-version-id">({{ version.softwareVersionId }})</span>
                  </span>
                  <div
                    matListItemMeta
                    class="button-container">
                    <button
                      mat-icon-button
                      color="primary"
                      [matMenuTriggerFor]="menu">
                      <mat-icon svgIcon="information"></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <div class="description-popover">
                        <h6 class="tooltip-font">
                          {{
                            localizationConstants.TECH_COVER_SOFTWARE_SOFTWARE_DESCRIPTION
                              | translate
                          }}
                        </h6>
                        <p>{{ release.softwareDescription }}</p>
                      </div>
                    </mat-menu>
                    <button
                      mat-icon-button
                      type="button"
                      color="primary"
                      class="button button-action software-release-icon"
                      (click)="onReleaseNoteDownloadClick(version.softwareMetadataId)"
                      [title]="
                        localizationConstants.TECH_COVER_SOFTWARE_RELEASE_RELEASE_NOTES_BUTTON_TITLE
                          | translate
                      ">
                      <mat-icon svgIcon="catalog"></mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      type="button"
                      color="primary"
                      [disabled]="!release.canBeDownloaded"
                      (click)="onSoftwareDownloadClick(version.softwareMetadataId)"
                      class="button button-action software-release-icon"
                      [title]="
                        localizationConstants.TECH_COVER_SOFTWARE_RELEASE_DOWNLOAD_BUTTON_TITLE
                          | translate
                      ">
                      <mat-icon svgIcon="cloud-download"></mat-icon>
                    </button>
                  </div>
                </mat-list-item>
              </ng-container>
              <mat-divider
                *ngIf="!last"
                class="release-divider"></mat-divider>
            </ng-container>
          </mat-list>
        </mat-card-content>
        <mat-card-content
          *ngIf="!techCoverTicketsDataService.supportedSoftware()?.length"
          class="software-release-no-content">
          {{ localizationConstants.TECH_COVER_RECENT_UPDATES_NO_CONTENT | translate }}
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
